import { useState } from "react"
import { Form, Input, Button, message } from "antd"
import { MailOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router"
import { sendPasswordlessLogin } from "../functions/requests"

export default function LoginForm() {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState(1)
  const navigate = useNavigate()

  const sendLink = async (values) => {
    setLoading(true)
    console.log({ values })

    try {
      const output = await sendPasswordlessLogin(values.email)

      console.log({ output })

      if (!output.ok) {
        message.error(
          "Failed to send login link. Please contact administrator.",
        )
        return
      }
      message.success(
        "Email sent! Please check your email for the verification code.",
      )
    } catch (err) {
      message.error(err)
    } finally {
      setLoading(false)
      setStep(2)
    }
  }

  return (
    <>
      {step === 1 && (
        <Form form={form} layout="vertical" onFinish={sendLink}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="you@example.com" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Send Email Verification Code
            </Button>
          </Form.Item>
        </Form>
      )}

      {step === 2 && (
        <div>
          <p>Please Check your email to login!</p>
          <Button type="primary" onClick={() => navigate("/")} block>
            Return to Homepage
          </Button>
        </div>
      )}
    </>
  )
}
